import { z } from "zod"
import { Id } from "./ids.js"

export const AuditCategory = z.enum(["workspace", "team", "channels", "automations", "campaigns", "contacts", "moderation", "consent"])
export type AuditCategory = z.infer<typeof AuditCategory>

export const AuditEvent = z.object({
  id: Id,
  createdAt: z.iso.datetime(),
  actorUserId: z.string().nullable(),
  actorName: z.string(),
  category: AuditCategory,
  action: z.string(),
  summary: z.string(),
  resourceType: z.string().nullable(),
  resourceId: z.string().nullable(),
  resourceLabel: z.string().nullable(),
  result: z.enum(["success", "recorded", "failed"]),
  metadata: z.record(z.string(), z.unknown()).nullable(),
})
export type AuditEvent = z.infer<typeof AuditEvent>

export const AuditQuery = z.object({
  q: z.string().trim().max(200).optional(),
  actorUserId: z.string().optional(),
  category: AuditCategory.optional(),
  from: z.iso.datetime().optional(),
  to: z.iso.datetime().optional(),
  cursor: z.string().optional(),
  limit: z.coerce.number().int().min(1).max(200).default(50),
})
export type AuditQuery = z.infer<typeof AuditQuery>

export const AuditPage = z.object({ events: z.array(AuditEvent), nextCursor: z.string().nullable() })
export type AuditPage = z.infer<typeof AuditPage>
